// Port of src/app/components/nav-bar/home/upload-responses/upload-responses.component.{ts,html,scss}
// (mypart-upload-responses). [@pixelateInOutDelay] → CSS enter class from
// react/src/animations/pixelateInOutDelay.ts. The WritableSignal input became a
// plain value prop; the sendToMainEvent output became onSendToMain.

import { useEffect, useRef, useState } from 'react';
import { PIXELATE_IN_OUT_DELAY_ENTER_CLASS } from '../../animations/pixelateInOutDelay';
import './UploadResponses.scss';

export interface UploadResponsesProps {
  fileUploadResponse: { key: string; value: string }[] | undefined;
  onSendToMain: (value: string | undefined) => void;
}

export default function UploadResponses({ fileUploadResponse, onSendToMain }: UploadResponsesProps) {
  const [countdown, setCountdown] = useState(10);
  const countdownIntervalRef = useRef<ReturnType<typeof setInterval> | undefined>(undefined);
  // Latest values for the interval callback (mirrors Angular instance fields).
  const fileUploadResponseRef = useRef(fileUploadResponse);
  fileUploadResponseRef.current = fileUploadResponse;
  const onSendToMainRef = useRef(onSendToMain);
  onSendToMainRef.current = onSendToMain;

  const clearCountdown = () => {
    if (countdownIntervalRef.current) {
      clearInterval(countdownIntervalRef.current);
      countdownIntervalRef.current = undefined;
    }
  };

  // ngOnInit → startCountdown; ngOnDestroy → clearCountdown.
  useEffect(() => {
    setCountdown(10);
    countdownIntervalRef.current = setInterval(() => {
      setCountdown(v => {
        const next = v - 1;
        if (next <= 0) {
          clearCountdown();
          const first = fileUploadResponseRef.current?.[0];
          if (first) {
            onSendToMainRef.current(first.value);
          }
        }
        return next;
      });
    }, 1000);
    return clearCountdown;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const selectOption = (value: string | undefined) => {
    clearCountdown();
    onSendToMain(value);
  };

  const renderBubbles = (extraBubbleClass: string) => (
    <>
      {fileUploadResponse?.map((prompt, index) => {
        const first = index === 0;
        return (
          <div key={prompt.key}
               onClick={() => selectOption(prompt.value)}
               className={`bubble${extraBubbleClass}${first ? ' recommended' : ''}`}>
            {first && (
              <span className="recommended-badge">
                Recommended — starting in {countdown}s
              </span>
            )}
            <p title={prompt.key}>{prompt.value}</p>
          </div>
        );
      })}
    </>
  );

  return (
    <div className="upload-responses">
      <section className="big-screen">
        <section className={`bottom-boxes bottom-boxes-bubble ${PIXELATE_IN_OUT_DELAY_ENTER_CLASS}`}>
          {renderBubbles('')}
        </section>
      </section>

      <section className="small-screen">
        <section className={`small-bubbles ${PIXELATE_IN_OUT_DELAY_ENTER_CLASS}`}>
          {renderBubbles(' p-4')}
        </section>
      </section>
    </div>
  );
}
